module.exports = [
  {
    "field1": "2366",
    "Entity": "Brazil",
    "Code": "BRA",
    "Year": "1950",
    "Life.expectancy..years.": "50.06"
  },
  {
    "field1": "2376",
    "Entity": "Brazil",
    "Code": "BRA",
    "Year": "1960",
    "Life.expectancy..years.": "54.143"
  },
  {
    "field1": "2386",
    "Entity": "Brazil",
    "Code": "BRA",
    "Year": "1970",
    "Life.expectancy..years.": "58.911"
  },
  {
    "field1": "2396",
    "Entity": "Brazil",
    "Code": "BRA",
    "Year": "1980",
    "Life.expectancy..years.": "62.63"
  },
  {
    "field1": "2406",
    "Entity": "Brazil",
    "Code": "BRA",
    "Year": "1990",
    "Life.expectancy..years.": "66.343"
  },
  {
    "field1": "2416",
    "Entity": "Brazil",
    "Code": "BRA",
    "Year": "2000",
    "Life.expectancy..years.": "70.116"
  },
  {
    "field1": "2426",
    "Entity": "Brazil",
    "Code": "BRA",
    "Year": "2010",
    "Life.expectancy..years.": "73.619"
  },
  {
    "field1": "2435",
    "Entity": "Brazil",
    "Code": "BRA",
    "Year": "2019",
    "Life.expectancy..years.": "75.881"
  },
  {
    "field1": "3411",
    "Entity": "Chile",
    "Code": "CHL",
    "Year": "1950",
    "Life.expectancy..years.": "53.931"
  },
  {
    "field1": "3421",
    "Entity": "Chile",
    "Code": "CHL",
    "Year": "1960",
    "Life.expectancy..years.": "57.219"
  },
  {
    "field1": "3431",
    "Entity": "Chile",
    "Code": "CHL",
    "Year": "1970",
    "Life.expectancy..years.": "62.254"
  },
  {
    "field1": "3441",
    "Entity": "Chile",
    "Code": "CHL",
    "Year": "1980",
    "Life.expectancy..years.": "69.033"
  },
  {
    "field1": "3451",
    "Entity": "Chile",
    "Code": "CHL",
    "Year": "1990",
    "Life.expectancy..years.": "73.509"
  },
  {
    "field1": "3461",
    "Entity": "Chile",
    "Code": "CHL",
    "Year": "2000",
    "Life.expectancy..years.": "76.366"
  },
  {
    "field1": "3471",
    "Entity": "Chile",
    "Code": "CHL",
    "Year": "2010",
    "Life.expectancy..years.": "78.779"
  },
  {
    "field1": "3480",
    "Entity": "Chile",
    "Code": "CHL",
    "Year": "2019",
    "Life.expectancy..years.": "80.181"
  },
  {
    "field1": "5927",
    "Entity": "France",
    "Code": "FRA",
    "Year": "1950",
    "Life.expectancy..years.": "66.233"
  },
  {
    "field1": "5937",
    "Entity": "France",
    "Code": "FRA",
    "Year": "1960",
    "Life.expectancy..years.": "70.181"
  },
  {
    "field1": "5947",
    "Entity": "France",
    "Code": "FRA",
    "Year": "1970",
    "Life.expectancy..years.": "71.904"
  },
  {
    "field1": "5957",
    "Entity": "France",
    "Code": "FRA",
    "Year": "1980",
    "Life.expectancy..years.": "74.204"
  },
  {
    "field1": "5967",
    "Entity": "France",
    "Code": "FRA",
    "Year": "1990",
    "Life.expectancy..years.": "76.757"
  },
  {
    "field1": "5977",
    "Entity": "France",
    "Code": "FRA",
    "Year": "2000",
    "Life.expectancy..years.": "79.008"
  },
  {
    "field1": "5987",
    "Entity": "France",
    "Code": "FRA",
    "Year": "2010",
    "Life.expectancy..years.": "81.508"
  },
  {
    "field1": "5996",
    "Entity": "France",
    "Code": "FRA",
    "Year": "2019",
    "Life.expectancy..years.": "82.659"
  },
  {
    "field1": "8510",
    "Entity": "Japan",
    "Code": "JPN",
    "Year": "1950",
    "Life.expectancy..years.": "61.152"
  },
  {
    "field1": "8520",
    "Entity": "Japan",
    "Code": "JPN",
    "Year": "1960",
    "Life.expectancy..years.": "67.887"
  },
  {
    "field1": "8530",
    "Entity": "Japan",
    "Code": "JPN",
    "Year": "1970",
    "Life.expectancy..years.": "72.358"
  },
  {
    "field1": "8540",
    "Entity": "Japan",
    "Code": "JPN",
    "Year": "1980",
    "Life.expectancy..years.": "76.252"
  },
  {
    "field1": "8550",
    "Entity": "Japan",
    "Code": "JPN",
    "Year": "1990",
    "Life.expectancy..years.": "79.004"
  },
  {
    "field1": "8560",
    "Entity": "Japan",
    "Code": "JPN",
    "Year": "2000",
    "Life.expectancy..years.": "81.171"
  },
  {
    "field1": "8570",
    "Entity": "Japan",
    "Code": "JPN",
    "Year": "2010",
    "Life.expectancy..years.": "82.971"
  },
  {
    "field1": "8579",
    "Entity": "Japan",
    "Code": "JPN",
    "Year": "2019",
    "Life.expectancy..years.": "84.629"
  },
  {
    "field1": "15683",
    "Entity": "Spain",
    "Code": "ESP",
    "Year": "1950",
    "Life.expectancy..years.": "63.094"
  },
  {
    "field1": "15693",
    "Entity": "Spain",
    "Code": "ESP",
    "Year": "1960",
    "Life.expectancy..years.": "68.958"
  },
  {
    "field1": "15703",
    "Entity": "Spain",
    "Code": "ESP",
    "Year": "1970",
    "Life.expectancy..years.": "71.996"
  },
  {
    "field1": "15713",
    "Entity": "Spain",
    "Code": "ESP",
    "Year": "1980",
    "Life.expectancy..years.": "75.332"
  },
  {
    "field1": "15723",
    "Entity": "Spain",
    "Code": "ESP",
    "Year": "1990",
    "Life.expectancy..years.": "77.215"
  },
  {
    "field1": "15733",
    "Entity": "Spain",
    "Code": "ESP",
    "Year": "2000",
    "Life.expectancy..years.": "79.329"
  },
  {
    "field1": "15743",
    "Entity": "Spain",
    "Code": "ESP",
    "Year": "2010",
    "Life.expectancy..years.": "81.9"
  },
  {
    "field1": "15752",
    "Entity": "Spain",
    "Code": "ESP",
    "Year": "2019",
    "Life.expectancy..years.": "83.565"
  },
  {
    "field1": "17911",
    "Entity": "United Kingdom",
    "Code": "GBR",
    "Year": "1950",
    "Life.expectancy..years.": "68.708"
  },
  {
    "field1": "17921",
    "Entity": "United Kingdom",
    "Code": "GBR",
    "Year": "1960",
    "Life.expectancy..years.": "70.87"
  },
  {
    "field1": "17931",
    "Entity": "United Kingdom",
    "Code": "GBR",
    "Year": "1970",
    "Life.expectancy..years.": "71.948"
  },
  {
    "field1": "17941",
    "Entity": "United Kingdom",
    "Code": "GBR",
    "Year": "1980",
    "Life.expectancy..years.": "73.59"
  },
  {
    "field1": "17951",
    "Entity": "United Kingdom",
    "Code": "GBR",
    "Year": "1990",
    "Life.expectancy..years.": "75.689"
  },
  {
    "field1": "17961",
    "Entity": "United Kingdom",
    "Code": "GBR",
    "Year": "2000",
    "Life.expectancy..years.": "77.761"
  },
  {
    "field1": "17971",
    "Entity": "United Kingdom",
    "Code": "GBR",
    "Year": "2010",
    "Life.expectancy..years.": "80.352"
  },
  {
    "field1": "17980",
    "Entity": "United Kingdom",
    "Code": "GBR",
    "Year": "2019",
    "Life.expectancy..years.": "81.321"
  },
  {
    "field1": "18032",
    "Entity": "United States",
    "Code": "USA",
    "Year": "1950",
    "Life.expectancy..years.": "68.202"
  },
  {
    "field1": "18042",
    "Entity": "United States",
    "Code": "USA",
    "Year": "1960",
    "Life.expectancy..years.": "69.94"
  },
  {
    "field1": "18052",
    "Entity": "United States",
    "Code": "USA",
    "Year": "1970",
    "Life.expectancy..years.": "70.777"
  },
  {
    "field1": "18062",
    "Entity": "United States",
    "Code": "USA",
    "Year": "1980",
    "Life.expectancy..years.": "73.91"
  },
  {
    "field1": "18072",
    "Entity": "United States",
    "Code": "USA",
    "Year": "1990",
    "Life.expectancy..years.": "75.246"
  },
  {
    "field1": "18082",
    "Entity": "United States",
    "Code": "USA",
    "Year": "2000",
    "Life.expectancy..years.": "76.812"
  },
  {
    "field1": "18092",
    "Entity": "United States",
    "Code": "USA",
    "Year": "2010",
    "Life.expectancy..years.": "78.652"
  },
  {
    "field1": "18101",
    "Entity": "United States",
    "Code": "USA",
    "Year": "2019",
    "Life.expectancy..years.": "78.862"
  }
]
